import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberFirearmForm from '../../../components/forms/MemberFirearmForm';
import { useMemberFirearmApi } from '../../../hooks/useMemberFirearmApi';
import { useNavigate } from 'react-router-dom';
import { MemberFirearmDTO } from '../../../services/apiClient';

const MemberFirearmCreate: React.FC = () => {
  const { create, isLoading } = useMemberFirearmApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearms', href: '/admin/memberfirearms' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberFirearmDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate(-1);
    } catch (error) {
      console.error('Error creating MemberFirearm:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberfirearms"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin', 'User']}
      requiredPermission='Manage.MemberFirearm.Edit'
    >
      <MemberFirearmForm
        initialValues={{} as MemberFirearmDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate(-1)}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default MemberFirearmCreate;